import styled from "styled-components";
import Anchor from "./Anchor";

const FoldBanner = styled.div`
    background: url("/images/banner-matterport.jpg") no-repeat 50% 0;
    background-size: cover;
    height: calc(100vh - 88px);

    .container {
        padding: 0 15px;
        position: relative;
        height: 100%;
        align-items: center;
        display: flex;
    }

    h1 {
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
        line-height: 3rem;
    }

    h1 .featured {
        color: #FF5701;
        text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
        font-size: 5rem;
    }

    a.anchor {
        position: absolute;
        bottom: 100px;
        left: 50%;
        right: 50%;
        transform: translateX(-50%);
    }

    @media (max-width: 540px) {
        background-position: 70% 0;

        h1 {
            font-size: 1.2rem;
            position: absolute;
            bottom: 180px;
            line-height: 1.8rem;
        }

        h1 .featured {
            font-size: 2.5rem;
        }
    }
`;

type BannerProps = {
    children: any;
};

const Banner: React.FC<BannerProps> = ({ children }) => {
    return (
        <FoldBanner>
            <div className="container">
                <h1>
                    {children}
                </h1>

                <Anchor anchor="#quem-somos" />
            </div>
        </FoldBanner>
    );
};

export default Banner;
